<template>
  <div class="container">
    <div class="d-flex">
      <v-chip-group>
        <div v-for="(items, index) in item" :key="index" class="content-item">
          <img src="img/icons_v2/mi-delete@3x.png" class="icon-del" @click="remove(index)" />
          <img :src="items.pic" class="image-photo" />
        </div>
      </v-chip-group>
    </div>
  </div>
</template>

<script>
export default {
  props: ['item'],
  watch: {
    item(newValue) {
      console.log(newValue)
    }
  },
  methods: {
    remove(index) {
      this.$emit('remove', index)
    }
  }
}
</script>

<style lang="scss" scoped>
.content-item {
  // display: flex;
  position: relative;
  margin: 5px 20px 5px 0px;
}
.icon-del {
  position: absolute;
  width: 30px;
  height: 30px;
  right: -10px;
  top: -8px;
}
.image-photo {
  width: 170px;
  height: 180px;
  border-radius: 10px;
}
</style>
